import I18n from "i18n";

type ChangeItem = {
  id: string;
  old: unknown;
  new: unknown;
};

export function getHistoryChangedLabels(
  value: ChangeItem[],
  objectName: string
): string {
  if (!value?.length) return "";

  const labels = value.map(item => {
    const label = I18n.t(`${objectName}.attributes.${item.id}`) || item.id;
    return label;
  });

  return labels.join(", ");
}
